import React, { useState } from 'react';
// import { updateData } from '../../Helpers/requests';
import { r2_updateData } from '../../Helpers/r2_requests';
import { useNavigate } from 'react-router-dom';
import { GetAuth } from '../../Auth/AuthProvider';
import {
  Box,
  Grid,
  Typography,
  Divider,
  Button,
  TextField,
} from '@mui/material';

import DateAndTimePicker from '../CommonComponents/DateAndTimePicker';

import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import dayjs from 'dayjs';

import { converDateWithTimeForChrome } from '../../Helpers/dateHelpers';

const TimeAndAttendanceEdit = (props) => {
  const navigateBack = useNavigate();
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [forceUpdate, setForceUpdate] = useState(1);

  const thisRowData = props.thisRowData;
  const cancelEdit = props.cancelEdit;

  const startTime =
    thisRowData.start_time_override === null
      ? thisRowData.start_time
      : thisRowData.start_time_override;
  const endTime =
    thisRowData.stop_time_override === null
      ? thisRowData.stop_time === null || undefined
        ? ''
        : thisRowData.stop_time
      : thisRowData.stop_time_override;

  const [newStartTime, setNewStartTime] = useState(
    thisRowData.start_time_override
  );
  const [newEndTime, setNewEndTime] = useState(thisRowData.stop_time_override);

  const [ntMinutes, setNtMinutes] = useState(thisRowData.nt_minutes);
  const [ot1Minutes, setOt1Minutes] = useState(thisRowData.ot1_minutes);
  const [ot2Minutes, setOt2Minutes] = useState(thisRowData.ot2_minutes);

  const dataBlob = {
    timeline: {
      start_time_override: newStartTime,
      // === null
      //   ? newStartTime
      //   : converDateWithTimeForChrome(newStartTime)
      stop_time_override: newEndTime,
      // === null
      //   ? newEndTime
      //   : converDateWithTimeForChrome(newEndTime)
    },
  };

  const [value1, setValue1] = useState();

  const handleStartChange = (key, value) => {
    // console.log(key, value);

    // {
    let year = value['$y'].toString();
    let month = (value['$M'] + 1).toString().padStart(2, '0');
    let day = value['$D'].toString().padStart(2, '0');
    let hours = value['$H'].toString().padStart(2, '0');
    let minutes = value['$m'].toString().padStart(2, '0');

    // console.log(`${year}/${month}/${day} ${hours}:${minutes}`);
    const date = `${year}/${month}/${day} ${hours}:${minutes}`;
    setValue1(date);
    setNewStartTime(date);
    // }
  };

  const [value2, setValue2] = useState();

  const handleEndChange = (key, value) => {
    // console.log(key, value);

    // {
    let year = value['$y'].toString();
    let month = (value['$M'] + 1).toString().padStart(2, '0');
    let day = value['$D'].toString().padStart(2, '0');
    let hours = value['$H'].toString().padStart(2, '0');
    let minutes = value['$m'].toString().padStart(2, '0');

    const date = `${year}/${month}/${day} ${hours}:${minutes}`;
    setValue2(date);
    setNewEndTime(date);
    // }
  };

  // const handleDateChange = (val, item) => {
  //   const adjustedVal = converDateWithTimeForChrome(val)
  //     .replace(/\//g, '-')
  //     .replace(',', '');
  //   // console.log('DATE: ', val);
  //   switch (item) {
  //     case 'startTime':
  //       setNewStartTime(val);
  //       break;
  //     case 'endTime':
  //       setNewEndTime(val);

  //       break;
  //     default:
  //       break;
  //   }
  //   console.log(val);
  // };

  const handleSave = () => {
    const updateType = 'timeAndAttendance';
    // const path = '/admin/time&attendance';
    const uri =
      thisRowData.id === undefined
        ? `/r2_timelines`
        : `/r2_timelines/${thisRowData.id}`;
    r2_updateData({
      uri: uri,
      dataBlob: dataBlob,
      cancelEdit: cancelEdit,
      setForceUpdate,
      navigateBack,
      path: '/admin/time&attendance',
      logout: logout,
      enqNotification: enqNotification,
      updateMessage: 'Times updated',
      type: updateType,
    });
  };

  return (
    <Box sx={boxStyle}>
      <Grid container>
        <Grid xs={12} md={6}>
          <Typography variant='h4'>
            {`${thisRowData.tech_name} ${thisRowData.tech_surname}`}
          </Typography>
        </Grid>
        <Grid xs={12} md={6}>
          <Typography variant='h4'>
            {ticketType(thisRowData.entry_type)}
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      <Grid container>
        <Grid xs={12} md={6} marginTop={1} marginBottom={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              defaultDate={startTime}
              inputFormat='DD/MM/YYYY HH:mm'
              sx={{ background: '#fff', maxWidth: '80%' }}
              size='small'
              value={value1 ?? startTime}
              onChange={(val) => {
                handleStartChange('startTime', dayjs(val));
              }}
              renderInput={(props) => (
                <TextField
                  {...props}
                  sx={{ background: '#fff' }}
                  // fullWidth
                  size='small'
                />
              )}
            />
          </LocalizationProvider>

          {/* <DateAndTimePicker
            dateLabel='Clock In Time'
            defaultDate={startTime}
            handleDateChange={(val) => handleDateChange(val, 'startTime')}
          /> */}
        </Grid>
        <Grid xs={12} md={6} marginTop={1} marginBottom={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              defaultDate={startTime}
              inputFormat='DD/MM/YYYY HH:mm'
              sx={{ background: '#fff', maxWidth: '80%' }}
              size='small'
              value={value2 ?? endTime}
              onChange={(val) => {
                handleEndChange('date_scheduled', dayjs(val));
              }}
              renderInput={(props) => (
                <TextField
                  {...props}
                  sx={{ background: '#fff' }}
                  // fullWidth
                  size='small'
                />
              )}
            />
          </LocalizationProvider>
          {/* <DateAndTimePicker
            dateLabel='Clock Out Time'
            defaultDate={endTime}
            handleDateChange={(val) => handleDateChange(val, 'endTime')}
          /> */}
        </Grid>
      </Grid>
      <Divider />
      <Grid container>
        <Grid xs={12} md={4}>
          <Typography label='123' variant='h5'>
            Total Time:
          </Typography>
          <Typography label='123' variant='h6'>
            {setTime(ntMinutes)}
          </Typography>
        </Grid>
        <Grid xs={12} md={4}>
          <Typography variant='h5'>Over Time 1:</Typography>
          <Typography variant='h6'>{setTime(ot1Minutes)}</Typography>
        </Grid>
        <Grid xs={12} md={4}>
          <Typography variant='h5'>Over Time 2:</Typography>
          <Typography variant='h6'>{setTime(ot2Minutes)}</Typography>
        </Grid>
      </Grid>
      <Divider />
      <Box align='right'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={cancelEdit}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default TimeAndAttendanceEdit;

const setTime = (val) => {
  let hours = Math.floor(val / 60);
  hours = hours > 9 ? `${hours}` : `0${hours}`;
  let minutes = val % 60;
  minutes = minutes > 9 ? `${minutes}` : `0${minutes}`;
  return `${hours}h${minutes}`;
};

const ticketType = (val) => {
  switch (val) {
    case 'day_start':
      return 'Day Clock';
    case 'repair_ticket':
      return 'Repair Ticket';
    case 'install_ticket':
      return 'Install Ticket';
    default:
      break;
  }
};

const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};
